export const convertInchToFeet = (inchBase: number) => {
 const feet = Math.floor(inchBase/12);
 const sub = inchBase/12 - feet < 0 ? 0 : inchBase/12 - feet
 const inch = Math.round((sub) * 12) || 0
 return {
  feet, inch
 }
}